import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';

export function useTaskSubtasks(taskId: string | null) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TASK_KEYS.subtasks(activeOrganizationId, taskId ?? ''),
    queryFn: ({ signal }) => tasksService.getSubtasks(taskId!, signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId && !!taskId,
  });
}
